// extracted by mini-css-extract-plugin
export default {"checkbox":"e0z53fiC"};